<template>
    <div class="reply-item-wrapper">
        <TextLinkContent :data="data" :placeholder="placeholder" @inputChange="inputChange" />
        <span class="reply-type">{{ replyType }}</span>
    </div>
</template>

<script>
import TextLinkContent from "../TextLinkContent";

export default {
    name: "ReplyItem",
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    components: {
        TextLinkContent
    },
    computed: {
        replyType() {
            return this.$t(`zhiji.answer.replyType.${this.data.replyType}`);
        },
        placeholder() {
            return this.$t("zhiji.answer.packageWidge.wordsHolder");
        }
    },
    watch: {},
    methods: {
        inputChange(data) {
            this.$emit("replyTextChange", Object.assign({}, this.data, data));
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.div-textarea-container {
    height: 80px !important;
    border: 1px solid #d8e4f0 !important;
}

/deep/.textarea-tip {
    display: none;
}
.reply-item-wrapper {
    position: relative;
    margin-bottom: 8px;
    .reply-type {
        position: absolute;
        left: 10px;
        bottom: 10px;
    }
}
</style>
